export const details = {
	goBack: "VOLVER",
	edit: "Editar",
	confirm: "¿Está seguro de que desea cambiar la información de este cliente?",
	clientDetails: "Datos del cliente",
	consummationGiven: "Consumo otorgado",
	rechargesReturned: "Recargas devueltas",
	singleProductReturns: "Devolución de productos",
	paymentMethods: {
		app: "App",
		cash: "Efectivo",
		creditCard: "Crédito",
		debitCard: "Débito",
		zigPosCredit: "Zig post crédito",
		zigPosDebit: "Zig post débito",
		voucher: "Voucher",
		dashboard: "Panel",
		anticipated: "Anticipado",
		postEvent: "Post evento",
		ame: "Ame",
		deliveryOnline: "Delivery online",
		ifood: "Ifood",
		uber: "Uber",
		rappi: "Rappi",
		total: "Total",
		pix: "Pix",
		installment: "Pago en cuotas",
		foodVoucher: "Vale de Alimentación",
		noMethod: "No informado",
		online: "En línea",
		mbway: "Mbway",
	},
	data: {
		cpf: "RFC",
		email: "Correo electrónico",
		noEmail: "Sin correo electrónico registrado",
		phone: "Teléfono",
		noPhone: "Sin teléfono registrado",
		birthDate: "Nacimiento",
		notRegistered: "Fecha no registrada",
		remaningValue: "Saldo disponible en el local",
		hasApp: "Tiene Aplicación",
		checkIn: "Entrada",
		checkOut: "Salida",
		noRegistry: "Sin registro",
		notDefined: "No ocurrió",
		at: "a las",
		showMore: "ver más información",
		showLess: "ver menos",
		clientsAtTag: "Cantidad de clientes en la mesa",
	},
	tabs: {
		bonusAndDiscounts: "Bonos y Descuentos",
		debtorsReport: "Cuentas abiertas",
		ticketsByUserReport: "Control de fichas",
	},
	sheet: {
		fileName: "historico-consolidado",
		withoutInfo: "Sin información para mostrar",
		summary: {
			title: "Resumen",
			recharges: "Recargas",
			rechargesFromOtherEvents: "Recargas de otros eventos",
			notSyncRecharges: "Recargas no sincronizadas",
			notUsedRecharges: "Recargas no utilizadas",
			rechargeDevolutions: "Devolución de Recargas",
			rechargeBalance: "Saldo de recargas",
			bonusReceveid: "Bono Recibido",
			entrances: "Entradas",
			products: "Productos",
			service: "Servicio",
			totalConsumption: "Consumo Total",
			payments: "Pagos",
			paymentsInOtherEvents: "Pagos en otros eventos",
			openedBill: "Cuentas abiertas",
			minimumConsumptionUsed: "Consumo mínimo utilizado",
			notUsedMinimumConsumption: "Consumo mínimo no utilizado",
			refundPostPayment: "Reembolso de pago",
			columns: {
				method: "Tipo",
				value: "Valor",
			},
			bonusPayments: "Pago con bono remanente",
			singleProductReturns: "Devolución de producto",
		},
		consumption: {
			title: "Consumo",
			columns: {
				name: "Nombre",
				count: "Cantidad",
				value: "Valor",
			},
		},
		recharges: {
			title: "Recargas",
			columns: {
				method: "Método",
				value: "Valor",
			},
		},
		payments: {
			title: "Pagos",
			columns: {
				method: "Tipo",
				value: "Valor",
			},
		},
		actions: {
			title: "Acciones",
			columns: {
				method: "Tipo",
				value: "Valor",
			},
		},
		transactionalHistory: {
			columns: {
				transaction: "transacción",
				seller: "vendedor",
				value: "valor",
				id: "id",
				time: "horario de la transacción",
				sync: "sincronización",
				zigCode: "zigTag",
				bonusCategoryName: "categoría de bono",
			},
		},
		consumptionHistory: {
			title: "Historial de Consumo",
			consumption: "Consumo",
			servicePaidOnEvent: "Servicio pagado en el evento",
			amountConsumption: "Consumo total",
			columns: {
				date: "Fecha",
				type: "Tipo",
				item: "Item",
				qtd: "Cant",
				value: "Valor",
				discountValue: "Descuento",
			},
		},
	},
	downloadTable: {
		fileName: "historico-consolidado",
		recharges: {
			title: "Recargas",
			columns: {
				date: "Fecha",
				rechargesInEvent: "Recargas en el evento",
				rechargesFromOtherEvents: "Recargas de otros eventos",
				notSynchRecharges: "Recargas no sincronizadas",
				notUsedRecharges: "Recargas no utilizadas",
				rechargeDevolutions: "Devolución de Recargas",
			},
		},
		consumption: {
			title: "Consumo",
			columns: {
				date: "Fecha",
				entrances: "Entradas",
				products: "Productos",
				service: "Servicio",
				totalConsumption: "Consumo Total",
			},
		},
		payments: {
			title: "Pagos",
			columns: {
				date: "Fecha",
				paymentsInEvent: "Pagos en el evento",
				paymentsInOtherEvents: "Pagos de otros eventos",
				openedBill: "Cuentas abiertas",
				bonusPayments: "Pago con bono remanente",
			},
		},
		bonusAndConsumption: {
			title: "Consumo y Bonos",
			columns: {
				date: "Fecha",
				bonusReceived: "Bono recibido",
				consumptionUsed: "Consumo usado",
				notUsedConsumption: "Consumo no usado",
			},
		},
		actions: {
			title: "Acciones",
			columns: {
				date: "Fecha",
				removedTips: "Propinas eliminadas",
				postPaidLimitChanged: "Cambio en el límite post-pago",
				attachCount: "Tarjetas zig adjuntas",
				packages: "Paquetes",
				productRefunds: "Productos reembolsados",
				promotionsUsed: "Promociones usadas",
			},
		},
	},
	consolidatedHistory: {
		label: "Historial Consolidado",
		printInfo: "Imprimir Información",
		recharges: "Recargas",
		totalValue: "Valor",
		consumption: "Consumo",
		bonusAndConsumption: "Consumo/Bonos",
		payments: "Pagos",
		action: "Acción",
		quantity: "Cantidad",
		method: "Método",
		unknown: "Desconocido",
		balance: "Saldo",
		consumptionObligations: "Valor de consumo mínimo",
		consumptionObligationsNotUsed: "Sobrante",
		product: "Producto",
		qntt: "Cant.",
		value: "Valor",
		discount: "Descuento",
		isShared: "-(compartido)",
		totalConsumption: "Consumo total",
		others: "Otros",
		name: "Nombre",
		toolTipMarketPlaceDiscount:
			"Descuento del delivery (ifood, rappi, etc.). Descuento en el valor total del pedido.",
		formatters: {
			rechargesFromOtherEvents: "Recargas de otros eventos",
			rechargeDevolutions: "Recargas devueltas",
			rechargeDevolutionsFromOtherEvents: "Recargas devueltas de otros eventos",
			notSyncRecharges: "Recargas no sincronizadas",
			bonusReceived: "Bono recibido",
			minimumConsumptionUsed: "Consumo mínimo utilizado",
			notUsedMinimumConsumption: "Consumo mínimo no utilizado",
			tip: "Servicio",
			openedBillPayments: "Pago de cuentas abiertas",
			paymentsInEvent: "Pagos en el evento",
			paymentsInOtherEvents: "Pagos en otros eventos",
			openedBill: "Cuentas abiertas",
			notUsedRecharges: "Recargas no utilizadas",
			rechargesInEvent: "Recargas en el evento",
			entrances: "Entradas",
			products: "Productos",
			consumptionObligations: "Consumos mínimos",
			consumptionObligationsNotUsed: "Sobrante de consumos mínimos",
			productRefunds: "Productos reembolsados",
			packages: "Paquetes",
			promotionsUsed: "Promociones usadas",
			removedTip: "Propinas eliminadas",
			postPaidLimitChanged: "Cambio en el límite del post-pago",
			attachCount: "Tarjetas Zig adjuntas",
			bonusPayments: "Pago con bono remanente",
			refundPostPayment: "Reembolso de pago",
			marketPlaceDiscount: "Descuento del delivery",
			singleProductReturns: "Devolución de producto",
		},
	},
	transactionalHistory: {
		label: "Historial Transaccional",
		export: "Exportar a Excel",
		formatters: {
			attach: "Registro de tarjeta",
			attachToReserve: "Inclusión en el paquete",
			bonus: "Bono",
			changePostLimit: "Cambio de límite",
			consumeRecharge: "Devolución de recarga",
			detachAndRefundActivation: "Devolución de tarjeta",
			discount: "Descuento",
			entranceTransaction: "Entrada",
			minimumConsumption: "Consumo mínimo",
			postPayment: "Pago",
			productTransaction: "Compra",
			promotion: "Ganó promoción",
			recharge: "Recarga",
			refundRecharge: "Reembolso de recarga",
			refundTransaction: "Reembolso",
			sharedTransaction: "Pago compartido",
			tipRemoval: "Servicio eliminado",
			appPrePayment: "Pre-pago vía app",
			consumptionObligation: "Consumo Mínimo",
			zigDeviceSyncForce: "Sincronización forzada de saldo",
			transferProductTransaction: "Transferencia de producto",
			zigCardPixRefund: "Reembolso de pix",
			transferConsumptionObligation: "Transferencia de consumo obligatorio",
			refundPostPayment: "Reembolso de pago",
		},
		employee: "Vendedor",
		value: "Valor",
		id: "ID",
		hour: "Horario",
		sheet: {
			fileName: "historico-transaccional-de-",
			in: "-en-",
			title: "Historial transaccional de {{user}} en {{event}}",
			id: "ID",
			operation: "Operación",
			employee: "Vendedor",
			value: "Valor",
			date: "Fecha",
			hour: "Horario",
			bonusCategoryName: "Categoría de bono",
		},
		event: "Evento",
		paymentTable: {
			method: "Método",
			value: "Valor",
			name: "Pagadores",
			cpf: "RFC",
			acquirer: "Adquirente",
		},
		productTable: {
			name: "Producto",
			details: "Detalles",
			value: "Precio",
			count: "Cant.",
			discountValue: "Descuento",
			totalValue: "Valor final",
			total: "TOTAL",
			transferFrom: "Transferido de ",
			transferTo: "Transferido para ",
			item: "Item",
			section: "Etapa",
		},
		refundTable: {
			name: "Producto",
			count: "Cant.",
		},
		service: "Servicio",
		marketPlaceDiscount: "Descuento del delivery",
		toolTipMarketPlaceDiscount:
			"Descuento del delivery (ifood, rappi, etc.). Descuento en el valor total del pedido.",
		unknown: "Desconocido",
		loading: "Cargando...",
		acquirerModal: {
			unknown: "Desconocido",
			acquirer: "Adquirente",
			urlLabel: "url",
			cardHolderNumber: "Tarjeta",
			cardHolderName: "Nombre del titular",
			transactionType: "Tipo de transacción",
			notKnown: "No conocido",
			paidAmount: "Valor transaccionado",
		},
	},
	fiscalNotes: {
		label: "Facturas",
		send: "Enviar facturas por Correo",
		emit: "Emitir factura",
		mode: {
			nfe: "NF-e",
			nfse: "NFS-e",
			nfsen: "NFS-e Nacional",
			nfce: "NFC-e",
			sat: "SAT",
		},
		columns: {
			time: "Fecha/Hora",
			type: "Tipo",
			status: "Estado",
			links: "Enlaces",
		},
		invoiceStatus: {
			canceled: "Factura cancelada",
			issued: "Factura emitida",
			issuing: "Emitiendo factura",
			error: "Error al emitir",
		},
		showError: "Ver error",
		image: "Imagen",
		generate: "Generar {{type}}",
		at: "a las",
		empty: "Sin facturas del cliente para el período seleccionado.",
		modalError: {
			title: "Descripción del error",
			content: "Contacte al soporte y envíe este error",
			error: "Error",
		},
		cancelInvoice: {
			title: "¿Está seguro de que desea cancelar la factura?",
			okText: "Sí, cancelar factura",
		},
	},
	ticketByUserReport: {
		excel: {
			title: "Control de fichas - {{userName}}",
			filename: "control_de_fichas_{{userName}}",
		},
		columns: {
			product: "Producto",
			burnedTickets: "Fichas quemadas",
			refundedTickets: "Fichas reembolsadas",
			purchasedTickets: "Fichas compradas",
		},
		emptyState: {
			title: "Ninguna ficha consumida",
			description: "Usuario aún no ha comprado ninguna ficha",
		},
	},
	bonusAndDiscounts: {
		discounts: {
			label: "Descuentos",
			columns: {
				date: "Fecha",
				givenBy: "Dado por",
				reason: "Justificación",
				percentage: "Porcentaje",
				value: "Descuento",
			},
		},
		bonus: {
			label: "Bonos",
			columns: {
				date: "Fecha",
				givenBy: "Dado por",
				reason: "Justificación",
				totalValue: "Valor recibido",
				usedValue: "Valor gastado",
			},
		},
		sheet: {
			fileName: "bonos-y-descuentos",
			discount: {
				clientTitle: "Descuentos de {{client}}",
				title: "Descuentos",
				columns: {
					date: "Fecha",
					givenBy: "Dado por",
					reason: "Justificación",
					percentage: "Porcentaje",
					value: "Descuento",
				},
			},
			bonus: {
				clientTitle: "Bonos de {{client}}",
				title: "Bonos",
				columns: {
					date: "Fecha",
					givenBy: "Dado por",
					reason: "Justificación",
					totalValue: "Valor recibido",
					usedValue: "Valor gastado",
				},
			},
		},
	},
	issueNotes: "Emisión de facturas",
	invoices: {
		alert:
			"Si desea agrupar las facturas de otros clientes con las del ya seleccionado, solo agregue los clientes a continuación",
		generateServiceFee: "Generar tarifa de servicio proporcional",
		cpfPlaceholder: "Ingrese un RFC",
		nifPlaceholder: "Ingrese un NIF",
		client: "Cliente",
		valueToEmit: "Valor a emitir",
		totalNotissued: "Total no emitido",
		otherCPF: "Emitir para otro RFC",
		otherNIF: "Emitir para otro NIF",
		otherCNPJ: "Emitir para otro RFC",
		noCPForCNPJ: "Emitir sin RFC",
		noNIF: "Emitir sin NIF",
		issueTo: "Emitir para",
		cpf: "RFC",
		nif: "NIF",
		cnpj: "RFC",
		cnpjPlaceholder: "Ingrese un RFC",
		empty: "No hay transacciones para emitir.",
		products: "Productos",
		count: "Cantidad",
		discountValue: "Descuento",
		value: "Valor",
		id: "Transacción",
		date: "Hora y Fecha",
		unitValue: "Valor Total",
		razaoSocial: "RAZÃO SOCIAL",
		inscricaoEstadual: "INSCRIÇÃO ESTADUAL",
		indicadorInscricaoEstadual: "INDICADOR INSCRICÃO ESTADUAL",
		indicadorInscricaoEstadualOptions: {
			ContribuinteICMS: "Contribuinte ICMS",
			ContribuinteIsento: "Contribuinte Isento",
			NaoContribuinte: "Não contriibuinte",
			none: "Não informar",
		},
		shouldAddAddressQuestion: "Adicionar endereço do tomador?",
		issueWithAdress: "Sim, adicionar endereço do tomador",
		issueWithoutAdress: "Não, emitir sem endereço",
		infoCNPJSection: "Dados do CNPJ",
		addressSection: "Endereço",
		address: {
			cep: "CEP",
			logradouro: "logradouro",
			numero: "numero",
			bairro: "bairro",
			municipio: "municipio",
			uf: "UF",
			complemento: "complemento",
		},
		steps: {
			buyers: "Compradores",
			transactions: "Transacciones no emitidas",
			consumption: "Consumo Mínimo no emitido",
			emission: "Emisión",
			receipientExtraInfo: "Informações extras",
		},
	},
	printable: {
		bonus: "Bono",
		recharge: "Recarga",
		date: "Fecha",
		author: "Autor",
		total: "Total",
		expired: "Expirada",
		used: "Utilizado",
		method: "Método",
		refunded: "Reembolsado",
		purchase: "Compra",
		shared: "Compartida",
		service: "Servicio",
		products: "Productos",
		name: "Nombre",
		count: "Cantidad",
		discount: "Descuento",
		totalProducts: "Total ({{count}} Productos)",
		paidBill: "Cuenta pagada",
		cashier: "Cajero",
		payments: "Pagos",
		paymentMethod: "Método de pago",
		payers: "Pagadores",
		value: "Valor",
		cpf: "rfc",
		email: "Correo electrónico",
		phone: "Teléfono",
		zigcode: "Zigcode",
		unavailable: "No disponible",
	},
	sendByEmail: {
		nfce: "Consumo (NFC-e)",
		nfse: "Servicio (NFS-e)",
		sat: "Consumo (SAT)",
		sendEmail: "Enviar correo",
		datetime: "Fecha/Hora",
		type: "Tipo",
		sendInvoucesByEmail: "Enviar facturas por correo",
		invoices: "Facturas",
		email: "Correo electrónico",
	},
	checkOutMethod: {
		biometry: "Biometría",
		pdv: "PDV",
		app: "App",
		menu: "Menú en línea",
		automatic: "Automático",
	},
};
